import * as React from "react";
import { HashTagLink } from "source/app/presentation/MainPanel/Dreams/HashTags/Link/HashTagLink";
import { hashTagsService } from "../../../../../../../motw_core/Services/HashTagsService";
import { GetDreamRows } from "./GetDreamRows";
import { GetActiveDreamHashTags } from "./Helpers/GetActiveDreamHashTags";

export function DreamHashTags({ shouldDisplay }: { shouldDisplay: boolean }) {
    if (!shouldDisplay) {
        return null;
    }

    const dreamRows = GetDreamRows();
    const hashTags = hashTagsService.GetAllDreamHashTags(dreamRows);

    return (
        <div>
            <div
                style={{
                    display: `flex`,
                    flexWrap: `wrap`,
                    justifyContent: `center`,
                    marginTop: `6px`,
                }}
            >
                {hashTags.map((hashTag) => (
                    <HashTagLink
                        {...{
                            hashTag,
                            key: hashTag,
                        }}
                    />
                ))}
            </div>
        </div>
    );
}
